<template>
  <div class="search-bar">
    <vue-autosuggest
      v-model="query"
      :suggestions="suggestions"
      :input-props="{
        id: 'autosuggest__input',
        placeholder: 'Rechercher'
      }"
      @input="onInputChange"
      @selected="selectHandler"
      @focus="emptyGeocoder"
    >
      <template slot-scope="{ suggestion }">
        <span>
          <span
            class="address"
            v-html="suggestion.item.highlight || suggestion.item.nom"
          ></span>
        </span>
      </template>
    </vue-autosuggest>
    <div class="search-bar-button">
      <img
        v-if="!searchActive"
        class="icon"
        src="./search.svg"
        alt="search"
        srcset=""
        @click="search"
      />
      <div v-else style="line-height: 11px" @click="emptyGeocoder">x</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { VueAutosuggest } from 'vue-autosuggest'
async function isearch(text, bbox) {
  const response = await axios.get(
    'https://geoegl.msp.gouv.qc.ca/apis/icherche/geocode',
    {
      params: {
        type: 'municipalites,adresses',
        q: text,
        geometry: 'center',
        extent: bbox.join()
      }
    }
  )
  return response.data
}
export default {
  components: {
    VueAutosuggest
  },
  props: {
    searchBbox: {
      type: Array
    },
    features: {
      type: Array
    }
  },
  data() {
    return {
      query: '',
      suggestions: [],
      searchActive: false
    }
  },
  methods: {
    async onInputChange(text) {
      if (text.length < 3) return
      this.suggestions = [{ data: [text] }]
      const result = await isearch(text, this.searchBbox)
      const result2 = this.features.filter(e =>
        e.properties["Nom de l'organisme"]
          .toLowerCase()
          .includes(text.toLowerCase())
      )
      const features2 = result2.map(f => ({
        highlight: '<i>' + f.properties["Nom de l'organisme"] + '</i>',
        nom: f.properties["Nom de l'organisme"],
        coordinates: f.geometry.coordinates
      }))
      const features = result.features.map(f => ({
        highlight: f.highlight.title,
        nom: f.properties.nom,
        coordinates: f.geometry.coordinates
      }))
      this.suggestions = [{ data: [...features2, ...features] }]
    },
    search() {
      if (this.suggestions.length) {
        this.$emit('results', this.suggestions[0].data[0].coordinates)
        this.searchActive = true
      }
    },
    async selectHandler(selected) {
      if (selected) {
        this.query = selected.item.nom
        this.$emit('results', selected.item.coordinates)
        this.searchActive = true
      } else {
        if (!this.query.length) return
        const result = await isearch(this.query, this.searchBbox)
        if (result.features) {
          this.$emit('results', result.features[0].geometry.coordinates)
          this.searchActive = true
        }
      }
    },
    emptyGeocoder() {
      this.query = ''
      this.suggestions = []
      this.$emit('empty')
      this.searchActive = false
    }
  }
}
</script>

<style lang="scss">
.search-bar {
  em {
    /* font-weight: bolder; */
    /* font-style: normal; */
  }
  height: 28px;
  display: flex;
  border-radius: 4px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
  &-button {
    padding: 8px;
    background-color: white;
    cursor: pointer;
  }
}
.name {
  color: black;
}
.address {
  /* color: grey; */
}
#autosuggest {
  float: left;
  padding: 0;
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  /* font-size: 15px; */
  border: none;
  /* border-radius: 4px; */
  padding: 10px;
  width: 240px;
  height: 28px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}
#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.autosuggest__results-container {
  padding-bottom: 0;
  position: relative;
}
.autosuggest__results {
  /* font-weight: 300; */
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  overflow: auto;
}
.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 6px;
  /* font-size: 16px; */
}
#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}
.autosuggest__results .autosuggest__results-before {
  background-color: #03c9ff;
  color: white;
  font-size: 14px;
  margin-left: 0;
  padding: 12px;
  border-top: 1px solid lightgray;
  font-weight: bold;
  cursor: default;
}
.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results_item.autosuggest__results-item-highlighted {
  background-color: #ddd;
}
</style>
